import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/common/Seo";
import { Marquee } from "@/components/common/Marquee";
import { Hero } from "@/components/home/Hero";
import { FeaturedApp } from "@/components/home/FeaturedApp";
import { Manifesto } from "@/components/home/Manifesto";
import { ContactSection } from "@/components/home/ContactSection";
import { AppCard } from "@/components/apps/AppCard";
import { HealthDisclaimer } from "@/components/common/HealthDisclaimer";
import { Reveal, SectionLabel } from "@/components/common/Reveal";
import { visibleApps, apps } from "@/data/apps";

export default function Home() {
  const hasHealthApp = apps.some((a) => a.isHealthApp && a.status !== "draft");

  return (
    <>
      <Seo path="/" />
      <Hero />
      <Marquee />
      <FeaturedApp />
      <Manifesto />

      <section className="py-24 sm:py-32" data-testid="home-our-apps">
        <div className="shell">
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <SectionLabel>Our apps</SectionLabel>
              <Reveal delay={0.06}>
                <h2 className="font-display mt-6 max-w-xl text-2xl font-black leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl">
                  Everything we have shipped, and what is next.
                </h2>
              </Reveal>
            </div>
            <Reveal delay={0.1}>
              <Link
                to="/apps"
                data-testid="our-apps-view-all"
                className="link-underline inline-flex items-center gap-1.5 text-sm text-white"
              >
                View all apps
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>

          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {visibleApps.map((app, i) => (
              <AppCard key={app.id} app={app} index={i} />
            ))}
            <Reveal delay={visibleApps.length * 0.08}>
              <div
                data-testid="apps-slot-placeholder"
                className="flex h-full min-h-[280px] flex-col justify-center rounded-3xl border border-dashed p-8"
                style={{ borderColor: "rgba(255,255,255,0.14)" }}
              >
                <p className="font-display text-lg font-bold text-white/50">Next app</p>
                <p className="mt-2 text-sm leading-relaxed text-gray-500">
                  New apps are added by editing one file —{" "}
                  <span className="font-mono-x text-xs text-gray-400">src/data/apps.js</span>. The
                  listing, detail page, support selector and footer update automatically.
                </p>
              </div>
            </Reveal>
          </div>

          {hasHealthApp && (
            <Reveal delay={0.1}>
              <div className="mt-16">
                <HealthDisclaimer testId="home-health-disclaimer" />
              </div>
            </Reveal>
          )}
        </div>
      </section>

      <ContactSection />
    </>
  );
}
